import { IconButton, Stack, Tooltip } from "@mui/material";
import { ReactComponent as IconZoomPan } from "../../../images/zoom-pan.svg";
import { ReactComponent as IconCenter } from "../../../images/center.svg";
import l10n from "../../lib/l10n";
import { useCropperAction } from "@src/v3.0.0/store/cropper/cropper-actions";

function AlignControl() {
  const { dispatch: dispatchCropperAction } = useCropperAction();
  const centerCanvas = () => dispatchCropperAction({ centerCanvas: null });
  const adaptToCropBox = () => dispatchCropperAction({ fitCanvas: null });
  return (
    <Stack direction={'row'} gap={0.5} alignItems={'center'}>
      <Tooltip placement="top" title={l10n.ui_label_position_center}>
        <IconButton onClick={centerCanvas} size="small">
          <IconCenter />
        </IconButton>
      </Tooltip>
      <Tooltip placement="top" title={l10n.ui_label_position_adapt}>
        <IconButton onClick={adaptToCropBox} size="small">
          <IconZoomPan />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default AlignControl;